import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-internal-links',
  templateUrl: './internal-links.component.html',
  styleUrls: ['./internal-links.component.css'],
})
export class InternalLinksComponent {
  url: string = 'seoOffpageCampaigns';

  loading: boolean = false;
  saving: boolean = false;
  activeInternalLinksTab: string = 'All Opportunities'; // Default tab

  setActiveInternalLinksTab(tabName: string): void {
    this.activeInternalLinksTab = tabName;
  }

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedLocation: string = 'all'; // default location
  selectedUniverse: string = 'courier'; // default universe
  selectedCategory: string = ''; // empty = all categories

  pendingLocation: string = 'all';
  pendingUniverse: string = 'courier';
  pendingCategory: string = '';

  // Unique values extracted from the loaded campaigns
  uniqueLocations: string[] = [];
  uniqueUniverses: string[] = [];
  uniqueCategories: string[] = [];

  // ── Lookup tables ─────────────────────────────────────────────────────────
  locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
    { value: 'miami_fl', label: 'Miami, FL' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  keywordIntents = [
    { value: 'high_intent_local', label: 'High-Intent Local' },
    { value: 'broad_commercial', label: 'Broad Commercial' },
    { value: 'mixed_high_intent', label: 'Mixed High-Intent' },
    { value: 'informational', label: 'Informational' },
    { value: 'navigational', label: 'Navigational' },
    { value: 'brand_intent', label: 'Brand Intent' },
  ];

  // ── Loaded data ───────────────────────────────────────────────────────────
  /** All approved campaigns fetched from the API */
  allCampaigns: any[] = [];

  /** Currently selected (active) campaign after filter match */
  campaign: any = null;

  /** Active campaign _id – used when saving keyword changes */
  campaignId: string = '';

  // ── Derived view data ─────────────────────────────────────────────────────
  stats = {
    mappedKeywords: { value: 0, trend: '', up: true },
    mappedPages: { value: 0, trend: '', up: true },
    unmappedHighValue: { value: 0, trend: '', up: false },
    cannibalizationIssues: { value: 0, trend: '', up: false },
    mappingGaps: { value: 0, text: '' },
  };

  mappings: any[] = [];
  opportunities: any[] = [
    {
      sourcePage: '/blog/legal-courier-guide/',
      targetPage: '/legal-courier-miami/',
      relationship: 'Supporting → Primary',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'legal courier in Miami',
      context: 'High relevance in section: "Serving Law Firms"',
      priority: 'High',
      priorityClass: 'text-danger',
      confidence: '91%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
    {
      sourcePage: '/services/same-day/',
      targetPage: '/same-day-legal-courier/',
      relationship: 'Related Service',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'same-day legal courier',
      context: 'Natural fit in service description',
      priority: 'High',
      priorityClass: 'text-danger',
      confidence: '88%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
    {
      sourcePage: '/blog/courthouse-filing/',
      targetPage: '/courthouse-filing-service/',
      relationship: 'Supporting → Primary',
      status: 'Redirected',
      statusClass: 'bg-warning-light text-warning',
      suggestedAnchor: 'courthouse filing service',
      context: 'Link goes through a redirect',
      priority: 'High',
      priorityClass: 'text-danger',
      confidence: '98%',
      confidenceIconClass: 'text-success',
      action: 'Fix',
      actionBtnClass: 'btn-primary text-white',
    },
    {
      sourcePage: '/about-us/',
      targetPage: '/careers/',
      relationship: 'Organizational',
      status: 'Existing',
      statusClass: 'bg-success-light text-success',
      suggestedAnchor: 'join our team',
      context: 'Good contextual fit in company section',
      priority: 'Medium',
      priorityClass: 'text-warning',
      confidence: '76%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
    {
      sourcePage: '/corporate-clients/',
      targetPage: '/legal-courier-miami/',
      relationship: 'Topical Support',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'legal courier services',
      context: 'Mentions legal deliveries',
      priority: 'Medium',
      priorityClass: 'text-warning',
      confidence: '83%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
    {
      sourcePage: '/contact/',
      targetPage: '/faq/',
      relationship: 'User Support',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'frequently asked questions',
      context: 'Good user intent alignment',
      priority: 'Low',
      priorityClass: 'text-success',
      confidence: '72%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
    {
      sourcePage: '/services/',
      targetPage: '/medical-courier/',
      relationship: 'Cross Service',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'medical courier service',
      context: 'No current mention of medical services',
      priority: 'Medium',
      priorityClass: 'text-warning',
      confidence: '64%',
      confidenceIconClass: 'text-warning',
      action: 'Request Content',
      actionBtnClass: 'text-purple border-purple btn-outline-primary border',
    },
    {
      sourcePage: '/blog/shipping-tips/',
      targetPage: '/long-distance-courier/',
      relationship: 'Related Service',
      status: 'Missing',
      statusClass: 'bg-danger-light text-danger',
      suggestedAnchor: 'long distance courier',
      context: 'Relevant to shipping over long distances',
      priority: 'Medium',
      priorityClass: 'text-warning',
      confidence: '78%',
      confidenceIconClass: 'text-success',
      action: 'Review',
      actionBtnClass: 'btn-outline-primary border-primary text-primary',
    },
  ];

  pagesNeedingSupport = [
    {
      page: '/legal-courier-miami/',
      currentLinks: 8,
      recommendedRange: '12 - 15',
      gap: -6,
      priority: 'High',
      priorityClass: 'bg-danger-light text-danger',
    },
    {
      page: '/medical-courier-miami/',
      currentLinks: 3,
      recommendedRange: '8 - 12',
      gap: -7,
      priority: 'High',
      priorityClass: 'bg-danger-light text-danger',
    },
    {
      page: '/long-distance-courier/',
      currentLinks: 2,
      recommendedRange: '6 - 10',
      gap: -6,
      priority: 'Medium',
      priorityClass: 'bg-warning-light text-warning',
    },
    {
      page: '/courthouse-filing-service/',
      currentLinks: 4,
      recommendedRange: '8 - 12',
      gap: -4,
      priority: 'Medium',
      priorityClass: 'bg-warning-light text-warning',
    },
    {
      page: '/notary-runner/',
      currentLinks: 1,
      recommendedRange: '5 - 8',
      gap: -4,
      priority: 'Medium',
      priorityClass: 'bg-warning-light text-warning',
    },
  ];

  selectedOpportunity: any = this.opportunities[0];

  // Selected item for right-side panel
  selectedMapping: any = {
    keyword: '',
    status: '',
    tags: [],
    primaryUrlCandidate: '',
    architecturalFit: '',
    semanticCoverage: '',
    explicitIntentSupport: '',
    cannibalizationRisk: '',
    technicalEligibility: '',
    contentDepth: '',
    currentRankingUrl: '',
    mappingDivergence: '',
    aiRationale: '',
    _index: -1,
  };

  // Decision center form state
  decisionUrl: string = '';
  decisionNote: string = '';

  // ── Static UI-only widgets ────────────────────────────────────────────────
  highValueKeywords = [
    {
      keyword: 'miami to orlando courier',
      oppScore: 92,
      intent: 'Transactional',
      action: 'Create New Url',
    },
    {
      keyword: 'business courier miami',
      oppScore: 88,
      intent: 'Commercial',
      action: 'Create New Url',
    },
    {
      keyword: 'overnight courier miami',
      oppScore: 85,
      intent: 'Transactional',
      action: 'Review Architecture',
    },
    {
      keyword: 'law firm messenger miami',
      oppScore: 80,
      intent: 'Commercial',
      action: 'Create New Url',
    },
    {
      keyword: 'medical specimen courier miami',
      oppScore: 78,
      intent: 'Transactional',
      action: 'Create New Url',
    },
  ];

  cannibalizationIssuesList = [
    {
      primaryUrl: '/legal-services/',
      competingUrl: '/courier-services/',
      overlap: 18,
      severity: 'High',
    },
    {
      primaryUrl: '/same-day-courier/',
      competingUrl: '/rush-courier-service/',
      overlap: 12,
      severity: 'Medium',
    },
    {
      primaryUrl: '/medical-courier/',
      competingUrl: '/healthcare-courier/',
      overlap: 9,
      severity: 'Medium',
    },
    {
      primaryUrl: '/task-runner-services/',
      competingUrl: '/runner-services/',
      overlap: 7,
      severity: 'Low',
    },
  ];

  orphanPages = [
    {
      page: '/old-courier-services/',
      inIndex: 'Yes',
      backlinks: 2,
      status: 'Orphan',
    },
    {
      page: '/discount-courier/',
      inIndex: 'Yes',
      backlinks: 1,
      status: 'Orphan',
    },
    { page: '/temp-delivery/', inIndex: 'No', backlinks: 0, status: 'Orphan' },
    {
      page: '/legacy-routes-miami/',
      inIndex: 'Yes',
      backlinks: 0,
      status: 'Orphan',
    },
  ];

  signals = [
    {
      title: 'Explicit Intent Support Weak',
      to: 'ON-PAGE',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Primary URL Needs Internal Support',
      to: 'INTERNAL LINKS',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Technical Eligibility Review',
      to: 'TECHNICAL QA',
      status: 'Open',
      date: 'May 18',
    },
  ];

  recentActivity = [
    {
      action: 'Primary URL Assigned',
      details: 'same day courier miami -> /same-day-courier/',
      by: 'AI',
      date: 'May 18',
    },
    {
      action: 'Supporting URL Added',
      details: 'court filing courier miami -> /legal-services/',
      by: 'Felipe',
      date: 'May 17',
    },
    {
      action: 'Mapping Updated',
      details: 'rush legal courier service role changed to Supporting',
      by: 'AI',
      date: 'May 16',
    },
    {
      action: 'New URL Proposed',
      details: 'miami to orlando courier -> /routes/miami-to-orlando-courier/',
      by: 'AI',
      date: 'May 15',
    },
  ];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  // ── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.loadCampaigns();
  }

  // ── Data loading ──────────────────────────────────────────────────────────
  /**
   * Fetches ALL approved campaigns (no id in url).
   * After loading, derives unique filter values and auto-selects
   * the first campaign that matches the default location/universe.
   */
  loadCampaigns(): void {
    this.loading = true;

    // Build query params: only approved, no page limit needed for filtering
    const params = `?status=approved&limit=200`;

    this.dataService.getData(`${this.url}${params}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.allCampaigns = response.data;
          this.extractUniqueFilterValues();
          this.applyFilterAndSelect();
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaigns',
            'danger',
          );
          this.loading = false;
        }
      },
      (_err: any) => {
        this.messageService.add('Could not connect to the server.', 'danger');
        this.loading = false;
      },
    );
  }

  /** Pull distinct location / universe / category values from all loaded campaigns */
  extractUniqueFilterValues(): void {
    const locSet = new Set<string>();
    const uniSet = new Set<string>();
    const catSet = new Set<string>();

    this.allCampaigns.forEach((c: any) => {
      if (c.location) locSet.add(c.location);
      if (c.universe) uniSet.add(c.universe);
      if (c.category) catSet.add(c.category);
    });

    this.uniqueLocations = Array.from(locSet).sort();
    this.uniqueUniverses = Array.from(uniSet).sort();
    this.uniqueCategories = Array.from(catSet).sort();

    // If default selectedLocation is not present in data, fall back to first available
    if (
      this.uniqueLocations.length &&
      !this.uniqueLocations.includes(this.selectedLocation)
    ) {
      this.selectedLocation = this.uniqueLocations[0];
      this.pendingLocation = this.selectedLocation;
    }
    if (
      this.uniqueUniverses.length &&
      !this.uniqueUniverses.includes(this.selectedUniverse)
    ) {
      this.selectedUniverse = this.uniqueUniverses[0];
      this.pendingUniverse = this.selectedUniverse;
    }
  }

  /**
   * Filters allCampaigns by the active filter selections and
   * picks the first matching campaign to display its keyword mappings.
   */
  applyFilterAndSelect(): void {
    const matched = this.allCampaigns.filter((c: any) => {
      const locMatch =
        !this.selectedLocation || c.location === this.selectedLocation;
      const uniMatch =
        !this.selectedUniverse || c.universe === this.selectedUniverse;
      const catMatch =
        !this.selectedCategory || c.category === this.selectedCategory;
      return locMatch && uniMatch && catMatch;
    });

    if (matched.length === 0) {
      this.campaign = null;
      this.campaignId = '';
      this.mappings = [];
      this.resetStats();
      this.loading = false;
      return;
    }

    // Use the first matched campaign (best-fit)
    this.campaign = matched[0];
    this.campaignId = matched[0]._id;
    this.buildMappings();
    this.buildStats();
    this.loading = false;
  }

  /** Called whenever a filter dropdown changes */
  onFilterChange(): void {
    this.selectedLocation = this.pendingLocation;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedCategory = this.pendingCategory;

    this.selectedMapping = { ...this.selectedMapping, _index: -1 };
    this.applyFilterAndSelect();
  }

  // ── Mappings builder ──────────────────────────────────────────────────────
  buildMappings(): void {
    const keywords = this.campaign?.keywords || [];
    const intentLabel = this.getIntentLabel(this.campaign?.keywordIntent || '');

    this.mappings = keywords.map((kw: any, index: number) => {
      const hasUrl = kw.url && kw.url.trim();
      const mappingStatus = !hasUrl
        ? 'Unmapped'
        : kw.status === 'paused'
          ? 'Needs Review'
          : 'Mapped';

      return {
        index,
        keyword: kw.value || '',
        searchIntent: intentLabel || 'Commercial',
        primaryUrl: hasUrl ? kw.url.trim() : '-',
        urlRole: hasUrl ? 'Primary' : '-',
        architectureFit: hasUrl ? 'Mappable' : 'Needs New URL',
        semanticCoverage: hasUrl ? 'Strong' : '-',
        explicitIntentSupport: hasUrl ? 'Moderate' : '-',
        mappingStatus,
        keywordStatus: kw.status,
      };
    });

    // Auto-select first mapped item, or first overall
    const firstMapped = this.mappings.find((m) => m.mappingStatus === 'Mapped');
    const toSelect = firstMapped || this.mappings[0];
    if (toSelect) {
      this.selectMapping(toSelect);
    }
  }

  buildStats(): void {
    const keywords = this.campaign?.keywords || [];
    const mapped = keywords.filter((kw: any) => kw.url && kw.url.trim());
    const unmapped = keywords.filter((kw: any) => !kw.url || !kw.url.trim());
    const uniqueUrls = new Set(
      keywords.map((kw: any) => kw.url).filter(Boolean),
    );

    this.stats = {
      mappedKeywords: {
        value: mapped.length,
        trend: `${keywords.length} total keywords`,
        up: mapped.length >= unmapped.length,
      },
      mappedPages: {
        value: uniqueUrls.size,
        trend: 'unique URLs assigned',
        up: uniqueUrls.size > 0,
      },
      unmappedHighValue: {
        value: unmapped.length,
        trend: `${unmapped.length} without URL`,
        up: false,
      },
      cannibalizationIssues: {
        value: this.cannibalizationIssuesList.length,
        trend: 'detected issues',
        up: false,
      },
      mappingGaps: {
        value: this.needsReviewCount,
        text: this.needsReviewCount > 0 ? 'Need review' : 'All clear',
      },
    };
  }

  resetStats(): void {
    this.stats = {
      mappedKeywords: { value: 0, trend: 'No campaign loaded', up: false },
      mappedPages: { value: 0, trend: '', up: false },
      unmappedHighValue: { value: 0, trend: '', up: false },
      cannibalizationIssues: { value: 0, trend: '', up: false },
      mappingGaps: { value: 0, text: 'No campaign matched' },
    };
  }

  // ── Selection & Decision Center ───────────────────────────────────────────
  selectMapping(m: any): void {
    // Keeping for backwards compatibility
    this.selectedMapping = m;
  }

  selectOpportunity(row: any): void {
    this.selectedOpportunity = row;
  }

  approveMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = this.decisionUrl.trim();
    keywords[this.selectedMapping._index].status = 'active';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping approved and saved.', 'success');
            this.buildMappings();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error saving mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  rejectMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = '';
    keywords[this.selectedMapping._index].status = 'paused';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping rejected.', 'info');
            this.buildMappings();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error rejecting mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  // ── Computed getters ──────────────────────────────────────────────────────
  get mappedCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Mapped').length;
  }

  get unmappedCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Unmapped').length;
  }

  get needsReviewCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Needs Review')
      .length;
  }

  // ── Label helpers ─────────────────────────────────────────────────────────
  getIntentLabel(value: string): string {
    return this.keywordIntents.find((k) => k.value === value)?.label || value;
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }
}
